import { Box, styled } from "@mui/material";

export const PageLayoutRoot = styled(Box)({
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
  position: "relative",
  isolation: "isolate", // Creates stacking context for z-index
});
